
import React, { useContext, useEffect, useState } from 'react';
import { getReferalActivitie } from "../../api/referal";
import { AuthContext } from '../../context/AuthContext';

import {useNavigate} from 'react-router'
import FNavigator from '../../components/FNavigator/FNavigator';
import FInputt from "../../components/FInputt/FInputt";
import { AiOutlineShareAlt } from "@react-icons/all-files/ai/AiOutlineShareAlt";
import Swal from "sweetalert2";
import FModal from '../../components/FModal/FModal';

import { borderRadius, padding } from '@mui/system';
import ShareModal from '../../components/ShareModal/ShareModal';
import FContainer from '../../components/FContainer/FContainer';


const ReferalScreen = () => {
    const { checkToken } = useContext(AuthContext);


    const [referalData, setReferalData] = useState([]);
    const [currentWeek, setCurrentWeek] = useState(0);
    const [currentMonth, setCurrentMonth] = useState(0);
    const referalCode = JSON.parse(localStorage.getItem("tokenDecoded")).referralCode;
    const link = `Registrate en Fiado usando mi código de referido https://dev-app.tufiado.com/?referralCode=${referalCode}`;
    // const onShare = async () => {
    //   try {
    //     const result = await Share.share({
    //       message:
    //       `Registrate en Fiado usando mi código de referido ${link}`,
    //     });
    //     if (result.action === Share.sharedAction) {
    //       if (result.activityType) {
    //         // shared with activity type of result.activityType
    //       } else {
    //         // shared
    //       }
    //     } else if (result.action === Share.dismissedAction) {
    //       // dismissed
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // };
  
    const getActivity = async () => {
        checkToken()
      try {    
        const {data} = await getReferalActivitie();
        console.log(data);
        setReferalData(data.data);
        setCurrentMonth(data.data.referralsCurrentMonth);
        setCurrentWeek(data.data.referralsCurrentWeek);
        return true
      } catch (error) {
        console.log(error);
        return false
      }
    }
  
    useEffect(() => {
      getActivity();
    }, []);



    const [isOpen, setIsOpen] = useState(false);
    // <div className='font-bold md:text-xl text-lg' onClick={()=>{window.open(`https://api.whatsapp.com/send?text=${link}`,`_blank`);}}>Whatsapp</div>
    // <div onClick={()=>{window.open(`mailto:?body=${link}&subject=Unete a Fiado con mi código de referido.`);}}>Email</div>

    const clickOut = (e)=>{
        e.preventDefault();
        if (e.target === e.currentTarget) {
            setIsOpen(false)
        }
        
    }



    return(
    <FContainer>  

    <FModal isOpen={isOpen} onClickOut={(e)=>{clickOut(e)}} body={<ShareModal message={link}/>}  closeButtonAction={()=>{setIsOpen(false)}} title={'Compartir'} modalWidth={'max-w-3xl'} />
    
        <div className='mt-20'>
            <div className='flex content-center items-center flex-col mb-5'>
                <img src={require("../../components/assets/images/friends.png")}  className="w-56 md:w-96 "/>
                <div className='md:text-4xl text-xl font-bold text-center'>¡Invita a tus cuates a FIADO!</div>     
                <div className='text-lg md:text-xl font-regular text-center'>El primer lugar gana todos los sábados $10,000.00 MXN</div> 
                <div className='font-bold md:text-xl text-lg text-center'>Referidos de la semana: {currentWeek}</div>     
                <div className='font-bold md:text-xl text-lg text-center'>Referidos del mes: {currentMonth}</div>   
            </div>

            <div className='flex items-center flex-col mb-5'>
                <div class="flex-grow border-t border-gray-400 w-4/5"></div>
            </div>

            <div className='flex items-center flex-col mb-5'>     
            <div className='flex-row flex w-4/5 content-center items-center'>
                <div className='md:text-3xl  md:w-4/5 w-3/5 text-xl font-bold flex-1'>{referalCode}</div>
                <div className='md:text-2xl md:w-1/5 w-2/5 text-xl content-center items-center text-center flex-1'>
                    <FInputt styleProperties={{
                        backgroundColor:'bg-colorWhite',
                        textColor:'text-primary',
                        border:'border-2',
                       
                    }} type={'botton'} title={'Compartir'} icon={<AiOutlineShareAlt/>} onChange={(e)=>{
                        setIsOpen(true)
                        
                    }}/>
                </div>                     
            </div>
               
            </div>

        </div>

    </FContainer>)
} 

export default ReferalScreen;
